











import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import List from '@/views/document/section/List.vue';
import dokument from '@/store/modules/dokument';
import {ListSection} from '@/store/models';

@Component({components: {List}})
export default class IndustryAnalysis extends Vue {
  @Prop() readonly group!: any;

  get section(): ListSection {
    return dokument.getItem(500) as ListSection;
  }
}
